<template>
  <main-page :user="user" color="blue">
    <template v-slot:title> {{ canvas.name }} </template>

    <div class="container">
      <div class="row content">
        <div
          v-if="canvas && program"
          style="min-height: 750px; overflow: visible; margin-bottom: 100px"
          class="full-width"
        >
          <div class="text-md" style="text-align: left">
            Team Members: {{ fs.listNames(canvas.students) }}
          </div>
          <CanvasView
            :canEdit="false"
            :canvasData="canvas"
            :user="user"
            :program="program"
          />
        </div>
      </div>
    </div>

    <template v-slot:footer>
      <div class="col-6 text-right">
        <a
          class="btn btn-si-secondary"
          href="#/score?view=student"
        >
          Back
        </a>
      </div>
    </template>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import CanvasView from "@/components/CanvasView";

import CanvasService from "@/services/CanvasService";
import ProgramService from "@/services/ProgramService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";

export default {
  name: "CanvasSubmission",

  components: { MainPage, CanvasView },

  props: ["user"],

  data() {
    return {
      fs: fs,
      canvasID: this.$route.params.canvasID,
      canvas: null,
      program: null,
      team: null,
      expanded: false,
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      CanvasService.getCanvasPrefilled(this.canvasID)
        .then((r) => {
          console.log("RESP", r)
          this.canvas = r.data;
          ProgramService.getSectionProgram(this.canvas.section_id)
          .then((resp) => {
            this.program = resp.data;
          })
          .catch((e) => {
            console.log(e);
            Notie.error("Failed to load program", e);
          })
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to load canvas", e);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.button-container {
  display: flex;
  flex-direction: column;
  width: 170px;
}
.btn-no-border {
  padding: 5px;
}
.full-width {
  max-width: 90vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -45vw;
  margin-right: -45vw;
}
.feedback {
  width: 100%;
  margin-bottom: 100px;
  transition: opacity 0.5s;
}
</style>
